module.exports = {
  title: '共创家—平台后台管理',
  // baseUrl: 'https://platform1.jifenxitong.com/', // 测试项目地址
  baseUrl: 'https://applet1.jifenxitong.com/', // 测试项目地址
  baseApi: 'https://applet1.jifenxitong.com/admin', // 测试api请求地址
  $cdn: 'https://hyjy-oss.oss-cn-chengdu.aliyuncs.com/mp/assets/'
};
